// extracted by mini-css-extract-plugin
export default {"ModalComponent":"ModalComponent_B2LZ2","ModalComponent__headline":"ModalComponent__headline_MT9UB","ModalComponent__error":"ModalComponent__error_KjGFs"};